type Props = {
  title: string;
  children: React.ReactNode;
};

const CardViewWithData = ({ title, children }: Props) => {
  return (
    <>
      <div className="section-border-card-shadow section-bg-gray">
        <span className="fs-sm-1">{title}</span>
        {children}
      </div>
    </>
  );
};

export default CardViewWithData;
